import { Component, ElementRef, Input, OnInit } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { LoaderService, Message } from "@stdoutsrl/design-kit";

@Component({
  selector: "app-example-monouse-component",
  template: `<std-modal
    [show]="true"
    cardClass="!max-w-[90vw] min-w-[300px]"
    headerClass="bg-primary"
    [closeOnOutside]="false"
    (close)="autoDestory()"
  >
    <div header class="text-tertiary">Crea azienda</div>
    <div content>
      <std-input
        labelPosition="top"
        label="Email"
        [(ngModel)]="company.email"
      ></std-input>
      <std-input
        labelPosition="top"
        label="Nome"
        [(ngModel)]="company.firstName"
      ></std-input>
      <std-input
        labelPosition="top"
        label="Cognome"
        [(ngModel)]="company.lastName"
      ></std-input>
      <std-input
        labelPosition="top"
        label="Telefono"
        [(ngModel)]="company.phone"
      ></std-input>

      <div
        class="w-50% mt-4"
        [ngClass]="{
          'pointer-events-none opacity-50':
            !company.email ||
            !company.firstName ||
            !company.lastName ||
            !company.phone
        }"
      >
        <std-button
          buttonClass="bg-primary focus:bg-primary hover:bg-primary"
          class="w-full"
          (click)="createCompany()"
          >Crea</std-button
        >
      </div>
    </div>
  </std-modal>`,
  styles: [],
  standalone: false,
})
export class CreateCompanyComponent implements OnInit {
  constructor(
    private host: ElementRef<HTMLElement>,
    private rest: RestService,
    private message: Message,
    private loader: LoaderService
  ) {}

  @Input() fatherElement = {};
  @Input() fatherContaierRef: any;
  company: any = {
    email: "",
    firstName: "",
    lastName: "",
    phone: "",
  };

  ngOnInit(): void {}

  autoDestory() {
    this.host.nativeElement.remove();
  }

  createCompany() {
    this.loader.on();
    this.rest.post("/company/register", this.company).subscribe({
      next: (value) => {
        this.loader.off();
        this.message.showMessage("Azienda creata con successo", "success");
        this.fatherContaierRef.getTableData();
        this.autoDestory();
      },
      error: (value) => {
        this.loader.off();
        this.message.showMessage(
          "Errore nella creazione dell'azienda",
          "error"
        );
        this.autoDestory();
      },
    });
  }
}
